import React from "react";
import { useTranslation } from "react-i18next";
import { Modal, ModalBody, ModalHeader } from "reactstrap";

interface SyncModalProps {
  show ?: boolean;
  onDeleteClick ?: () => void;
  onCloseClick ?: () => void;
  recordId ?: string;
}

const SyncModal: React.FC<SyncModalProps> = ({ show, onDeleteClick, onCloseClick, recordId }) => {
  const { t } = useTranslation("translation", { keyPrefix: "FILE_MANAGER" });
  
  return (
    <Modal fade={true} isOpen={show} toggle={onCloseClick} centered={true}>
      <ModalHeader> <h4>{t("MODALS:SYNC:TITLE")}</h4></ModalHeader>
      <ModalBody className="py-3 px-5">
        <div className="mt-2 text-center">
          <i className="ri-refresh-line display-5 text-danger"></i>
          <div className="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
            <h4>{t("MODALS:SURE")}</h4>
          </div>
        </div>
        <div className="d-flex gap-2 justify-content-center mt-4 mb-2">
          <button
            type="button"
            className="btn w-sm btn-light material-shadow-none"
            data-bs-dismiss="modal"
            onClick={onCloseClick}
          >
            {t("MODALS:CLOSE")}
          </button>
          <button
            type="button"
            className="btn w-sm btn-soft-danger material-shadow-none"
            id="delete-record"
            onClick={onDeleteClick}
          >
            {t("MODALS:CONTINUE")}
          </button>
        </div>
      </ModalBody>
    </Modal>
  ) as unknown as JSX.Element;
};

export default SyncModal;